<template>
  <div class="home">
    <TagsList />
    <CardsList />
  </div>
</template>

<script>
import TagsList from '@/components/TagsList.vue'
import CardsList from '@/components/CardsList.vue'

export default {
  name: 'Home',
  components: {
    TagsList,
    CardsList
  }
}
</script>
